import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket(auth = {}) {
  const backendUrl = getBackendUrl();
  console.info("[ATND+ PWA] Socket backend:", backendUrl);
  console.info("[ATND+ PWA] Socket handshake auth:", auth);

  return openSocket(backendUrl, {
    transports: ["websocket", "polling"],
    withCredentials: true,
    auth,
  });
}

export default connectToSocket;
